import moment from 'moment'

moment.locale('it') // in base alla lingua scelta

export function date (value) {
  return moment(value).format('L')
}

export function dateNull (value) {
  return value ? moment(value).format('L') : ''
}

export function dateTime (value) {
  return moment(value).format('DD/MM/YYYY HH:mm')
}

export function dateTimeNull (value) {
  return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
}

export function time (value) {
  return moment(value).format('HH:mm')
}

export function toProperCase(value) {
  return value.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() })
}

export function toLowerCase(value) {
  return value.toLowerCase()
}

export function euro (value) {
  return !isNaN(value) && !!value && value !== '' && value !== null ? parseFloat(value).toFixed(2) + ' €': value || ''
}

export function dueDecimali (value) {
  return !isNaN(value) && !!value && value !== '' ? parseFloat(value).toFixed(2) : ''
}

export function percento (value) {
  return !isNaN(value) && !!value && value !== '' ? parseFloat(value).toFixed(2) + '%' : ''
}

export function fileSize (value) {
  if (!isNaN(value) && !!value && value !== '') {
    const v = parseInt(value)
    if (v < 1024) {
      return `${v} B`
    } else if (v < 1024*1024) {
      return `${(v / 1024).toFixed(2)} kB`
    } else {
      return `${(v / (1024 * 1024)).toFixed(2)} MB`
    }

  } else {
    return ''
  }
}